<div class="container">
    <button class="close-button" (click)="onClose()"> &#x2715;</button>
    <div style="text-align: center;">
        <p class="content">Oops, something went wrong. Please try again later.</p>
        <button mat-button class="retry-btn" (click)="retry()">Try Again</button>
    </div>
</div>